<template>
<div>
  <LoginDialog ref="loginDialog"></LoginDialog>
  <div
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
      class="header h1"
  style="height: 70px;display: flex;justify-content: center"
  >


    <div class="box">

      <div class="logo"><a href="/">

        <img src="https://www.yasubit.com/template/pc/skin/images/logo-head.png"><img src="https://www.yasubit.com/uploads/allimg/20210528/1-21052Q55040262.png"></a></div>

      <div class="right">

        <div v-if="!showMenu" @click="smallSize" class="m-btn">



          <span></span>

          <span></span>

          <span></span>

        </div>

        <div v-if="showMenu" @click="smallSize1" >
<i  class="el-icon-close"></i>
        </div>
        <!--        小尺寸菜单-->
        <div style="width:100%;position: fixed;background-color: #99a9bf;left: 0px;top:60px">
          <div >

            <el-row v-if="showMenu" class="tac">
              <el-col :span="24">
                <el-menu
                    default-active="2"
                    class="el-menu-vertical-demo"
                    @open="handleOpen"
                    @close="handleClose"
                    @select="handleMenuSelect"
                >
                  <template v-for="item in menuItems">
                    <el-submenu v-if="item.children && item.children.length > 0" :index="item.id.toString()" :key="item.id" >
                      <template slot="title">
                        <span style="display: flex;justify-content: center;align-items: center">{{ $t('message.' + item.key) || item.typename }}</span>
                      </template>
                      <el-menu-item-group>
                        <el-menu-item
                            v-for="childItem in item.children"
                            :key="childItem.id"
                            :index="childItem.id.toString()"

                        >
                          <span style="display: flex;justify-content: center;align-items: center">{{ $t('message.' + childItem.key) || childItem.typename }}</span>
                        </el-menu-item>
                      </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item v-else :index="item.id.toString()" :key="item.id">
                      <span style="display: flex;justify-content: center;align-items: center">{{ $t('message.' + item.key) || item.typename }}</span>
                    </el-menu-item>
                  </template>
                </el-menu>

              </el-col>

            </el-row>

          </div>

        </div>


        <div      class="menu-box">

         



          <div
              style="width: 50%; margin-right: 0%;display: flex "
              class="menu-links"
              mode="horizontal"
              v-for="item in sortedData"
              :key="item.id"
          >
            <div  style="margin-left: 52px;width: auto;white-space: nowrap;cursor: pointer;/* 设置鼠标指针样式为手掌 */"  @click="handleMenuItemClick(item)">
              <el-dropdown  style=""  type="primary" :show-timeout=300 >
                <span  style="display: flex;justify-content: center;align-items: center;" onmouseover="this.style.color='#52b3f1'" onmouseout="this.style.color=null" :style="{ color: isHovered ? '#000000' : '#ffffff' }"
                       class="el-dropdown-link">
                  {{ $t('message.' + item.key) || item.typename }}
                  <i style="margin-left: 0px" :style="{ color: isHovered ? '#000000' : '#ffffff' }" v-if="item.children && item.children.length > 0" class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu   v-if="item.children && item.children.length > 0" slot="dropdown">
                  <el-dropdown-item      v-for="childItem in item.children" :key="childItem.id" :command="childItem.id">
                    <div @click="handleDropdownItemClick(childItem)">
                      {{ $t('message.' + childItem.key) }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
      
          </div>

<!--<div ><img  style="height: 90px;width: 90px;padding:33px 0; " src="../../src/assets/img/lang.png"></div>-->

          <div v-if="isShow1" key="login1" style="background-color: transparent;border: none;margin-left: 50px;">

                        <div
                            @click="openLoginDialog"
                            class="login login-lg">
                          <img src="https://www.yasubit.com/template/pc/skin/images/icon1.png">
                          <img src="https://www.yasubit.com/template/pc/skin/images/icon1-1.png">
                           {{ $t('message.login') }}
                        </div>
            </div>
          <!--登陆后-->
          <div v-else key="login2" style="background-color: transparent;border: none;margin-left: 50px;">
          <el-dropdown  >
            <div class="login">
              <div class="user-name">
                <p>
                  <a >
                    {{ username }}				</a>
                  <span></span>
                </p>
              </div>
            </div>
<!--            <div style=" border-radius: 100px;"> <span  class="el-dropdown-link">-->
<!--    {{ username }}-->
<!--  </span> </div>-->
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><div @click="usercenter(1)">{{ $t('message.myOrder') }}</div></el-dropdown-item>
              <el-dropdown-item><div @click="usercenter(2)">{{ $t('message.myPlan') }}</div></el-dropdown-item>
              <!-- <el-dropdown-item><div @click="usercenter(3)">{{ $t('message.myTeam') }}</div></el-dropdown-item> -->
              <el-dropdown-item ><div @click="usercenter(4)">{{ $t('message.profile') }}</div></el-dropdown-item>
              <el-dropdown-item ><div @click="usercenter(5)">{{ $t('message.myMessage') }}</div></el-dropdown-item>
              <el-dropdown-item >
                <div @click="exit">{{ $t('message.exit') }}</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          </div>
            <!--         <el-menu-item style="background-color: #48a2f8; border-radius: 30px;" v-if="!isLogin"><span  @click="openLoginDialog">已登录</span>-->
            <!--         </el-menu-item>-->
          </div>
<!--          <div @click="openLoginDialog" class="login login-lg"><img src="https://www.yasubit.com/template/pc/skin/images/icon1.png"><img src="https://www.yasubit.com/template/pc/skin/images/icon1-1.png"> 登录</div>-->



        </div>
      </div>
    </div>





  </div>
</template>

<script>
import LoginDialog from "./loginFront.vue";
import Cookies from "js-cookie";
import contact from "@/views/contact.vue";
import Home from "@/views/Home.vue";
import Header1 from "@/views/header1.vue";
import { menuData } from '@/data/menuData.js'
import ImageCompress from "@/components/ImageCompress.vue";

export default {
  name: 'Header1',
  components: {
    ImageCompress,
    Header1,
    LoginDialog,
  },
  mounted() {
    // 获取当前页面的URL
    let currentUrl = window.location.href;
    // console.log(currentUrl)

    // 使用 split 方法通过等号分割字符串，并取第二部分
    let token = currentUrl.split('token=')[1];
    // 输出 token
    // console.log(token);
if(token){


  localStorage.setItem("loginToken", token)
  this.token=localStorage.getItem("loginToken")
}else {

  this.token=localStorage.getItem("loginToken")
}

    // this.exit()
    // console.log(localStorage.getItem("loginToken"))

    // console.log(JSON.parse(localStorage.getItem("loginStatus")));
    // 从localStorage中获取保存的数据
    if(this.token){
      //已登录
      this.isShow1=false
      this.isShow2=true

      this.getUserInfo()




    }else {
//未登录
      this.isShow1=true

      this.isShow2=false
    }





    // this.fetchData()
  },
  created() {
    // 直接使用静态数据并按sortOrder排序
    this.sortedData = this.menuData.data.position1.sort((a, b) => a.sortOrder - b.sortOrder)
  },
  data() {
    return {
      showMenu:false,
      menuItems: [],
      isHovered: false,
      username:'',
      token:'',
      id:0,
      data:[],
      data1:[],
      router: true,
      defaultActive: "/",
      isShow: false,
      isShow1:  false,
      isShow2:  false,
      user: {},
      isLogin: false,
      menuData: {
        "msg": "操作成功",
        "code": 200,
        "data": {
          "position1": [
            {
              "id": 91,
              "parentId": 0,
              "typename": "首页",
              "key": "home",
              "title": null,
              "isHidden": 0,
              "sortOrder": 1,
              "position": "1",
              "categoryId": 1,
              "categoryParentId": null,
              "newCategory": null,
              "children": [],
              "archiveList": []
            },
            {
              "id": 145,
              "parentId": 0,
              "typename": "行业应用",
              "key": "industry",
              "title": null,
              "isHidden": 0,
              "sortOrder": 2,
              "position": "1",
              "categoryId": 1,
              "categoryParentId": null,
              "newCategory": null,
              "children": [],
              "archiveList": []
            },
            {
              "id": 11,
              "parentId": 0,
              "typename": "服务与支持",
              "key": "support",
              "title": null,
              "isHidden": 0,
              "sortOrder": 3,
              "position": "1",
              "categoryId": 1,
              "categoryParentId": null,
              "newCategory": null,
              "children": [
              
                {
                  "id": 65,
                  "parentId": 11,
                  "typename": "常见问题",
                  "key": "faq",
                  "title": null,
                  "isHidden": 0,
                  "sortOrder": 1000,
                  "position": "1",
                  "categoryId": 2,
                  "categoryParentId": 11,
                  "newCategory": null,
                  "children": [],
                  "archiveList": []
                },
                {
                  "id": 67,
                  "parentId": 11,
                  "typename": "联系我们",
                  "key": "contact",
                  "title": null,
                  "isHidden": 0,
                  "sortOrder": 1000,
                  "position": "1,2,3",
                  "categoryId": 2,
                  "categoryParentId": 173,
                  "newCategory": null,
                  "children": [
                    {
                      "id": 69,
                      "parentId": 67,
                      "typename": "客服咨询",
                      "key": "service",
                      "title": null,
                      "isHidden": 0,
                      "sortOrder": 1000,
                      "position": null,
                      "categoryId": null,
                      "categoryParentId": null,
                      "newCategory": null,
                      "children": [],
                      "archiveList": []
                    }
                  ],
                  "archiveList": []
                }
              ],
              "archiveList": []
            },
            {
              "id": 9,
              "parentId": 0,
              "typename": "新闻资讯",
              "key": "news",
              "title": null,
              "isHidden": 0,
              "sortOrder": 4,
              "position": "1",
              "categoryId": 1,
              "categoryParentId": null,
              "newCategory": null,
              // "children": [
              //   {
              //     "id": 13,
              //     "parentId": 9,
              //     "typename": "行业新闻",
              //     "key": "industryNews",
              //     "title": null,
              //     "isHidden": 0,
              //     "sortOrder": 1000,
              //     "position": null,
              //     "categoryId": null,
              //     "categoryParentId": null,
              //     "newCategory": null,
              //     "children": [],
              //     "archiveList": []
              //   },
              //   {
              //     "id": 15,
              //     "parentId": 9,
              //     "typename": "技术动态",
              //     "key": "techNews",
              //     "title": null,
              //     "isHidden": 0,
              //     "sortOrder": 1000,
              //     "position": null,
              //     "categoryId": null,
              //     "categoryParentId": null,
              //     "newCategory": null,
              //     "children": [],
              //     "archiveList": []
              //   }
              // ],
              "archiveList": []
            },
           
            {
              "id": 1,
              "parentId": 0,
              "typename": "关于我们",
              "key": "about",
              "title": null,
              "isHidden": 0,
              "sortOrder": 1000,
              "position": "1",
              "categoryId": 2,
              "categoryParentId": 173,
              "newCategory": null,
              "archiveList": []
            },
            {
              "id": 999,
              "parentId": 0,
              "typename": "语言",
              "key": "language",
              "title": null,
              "isHidden": 0,
              "sortOrder": 1001,
              "position": "1",
              "categoryId": null,
              "categoryParentId": null,
              "newCategory": null,
              "children": [
                { "id": 1001, "parentId": 999, "typename": "zh", "key": "zh" },
                { "id": 1002, "parentId": 999, "typename": "en", "key": "en" },
                { "id": 1003, "parentId": 999, "typename": "ko", "key": "ko" },
                { "id": 1004, "parentId": 999, "typename": "ja", "key": "ja" }
              ],
              "archiveList": []
            }
          ]
        }
      },
      sortedData: []
    };
  },
  computed: {
    // 计算属性用于对数据进行排序
    sortedData: function () {
      return this.data.slice().sort((a, b) => a.sortOrder - b.sortOrder);
    }
  },
  methods: {



    // handleOpen(key, keyPath) {
    //   console.log(key, keyPath);
    // },
    // handleClose(key, keyPath) {
    //   console.log(key, keyPath);
    // },

    //小尺寸时点击显示首栏
    smallSize(){

      this.showMenu=true
    },
    smallSize1(){

      this.showMenu=false
    },


    //跳转到用户中心
    usercenter(item){
      if(item===1){
        this.$router.push({"path":"usercenter", query: { page: "order" }})
      }
      if(item===2){
        this.$router.push({"path":"usercenter", query: { page: "plan" }})
      }
      if(item===3){
        this.$router.push({"path":"usercenter", query: { page: "team" }})
      }
      if(item===4){
        this.$router.push({"path":"usercenter", query: { page: "info" }})
      }
      if(item===5){
        this.$router.push({"path":"usercenter", query: { page: "message" }})
      }
    },


    reloadPage() {
      // 使用 $router.replace 刷新当前页面
      this.$router.replace({ path: '/' });
    },
    goIndex(){
      this.$router.push({path:"/"})
    }


    ,
    getUserInfo(){

      // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
      const headers = { 'Authorization': `Bearer ${this.token}`     };

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http.get('yasubit/users/info', { headers })
          .then(response => {
            // 请求成功时更新数据
            // console.log('成功登录')
            this.username=response.data.data.nickname
            // console.log(response.data.data.username)

          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });



    },
    exit(){
      // console.log(333)
      this.isShow1=true
      this.isShow2=false

      localStorage.setItem("loginStatus",    JSON.stringify(this.isShow2));
      localStorage.removeItem("loginToken");
      console.log("localstorage",localStorage);
      // console.log(JSON.parse(localStorage.getItem("loginStatus")));
      window.location.href = "/";

    },
    handleDropdownItemClick(childItem) {
      // 语言菜单
      if (childItem.parentId === 999) {
        this.changeLang(childItem.typename);
        return;
      }
      if(childItem.id===65){
        this.$router.push({path:"FAQ"})
      }
      if(childItem.id===3){
        this.$router.push({path:"Technology"})
      }
      if(childItem.id===67){
        this.$router.push({path:"contact"})
      }

      if(childItem.newCategory===1){
        this.id=childItem.id
        sessionStorage.setItem('a', this.id);
        this.$router.push({
          name: 'templete2', // 使用路由的 name 属性

          params: { a: this.id }
        });
      }



    },


    handleMenuSelect(index, indexPath) {
      // index 是选中项的索引，indexPath 是选中项的路径
      console.log("选中项索引:", index);
      // console.log("选中项路径:", indexPath);
      // 在这里可以进行其他操作，根据需要处理选中项的信息
      index=parseInt(index)
      if(index===91){
        this.$router.push({path:"/"})
      }
      if(index===145){
        this.$router.push({path:"news"})
      }
      if(index===9){
        this.$router.push({path:"case"})
      }
      if(index===1){
        this.$router.replace({path:"about"})
      }


      if(index===65){
        this.$router.push({path:"FAQ"})
      }
      if(index===3){
        this.$router.push({path:"Technology"})
      }
      if(index===67){
        this.$router.push({path:"contact"})
      }

      if(index===214||index===215){
        this.id=index
        sessionStorage.setItem('a', this.id);
        this.$router.push({
          name: 'templete2', // 使用路由的 name 属性

          params: { a: this.id }
        });
      }


    },
    handleMenuItemClick(item) {
      // 处理 <el-menu-item> 被点击的逻辑
      // console.log('Menu item clicked:', item);

      // 添加其他逻辑...
      if(item.id===91){

        this.$router.push({path:"/"})

      }
      if(item.id===145){

        this.$router.push({path:"news"})

      }
      if(item.id===9){

        this.$router.push({path:"case"})



      }

      if(item.id===1){

        this.$router.replace({path:"about"})

      }


    },

    fetchData() {
      // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
      const headers = {};

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http.get('yasubit/website/list', { headers })
          .then(response => {
            // 请求成功时更新数据
            // console.log(1111111111);
            this.data = response.data.data.position1;
            this.menuItems=this.data
            // console.log( this.menuItems)
            // console.log(this.data)
            // console.log("底部")
          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });
    },


    questionNaire(){

      this.$router.push({path:"Guest"})

    },
    toContact(){
      this.$router.push({path:"contact"})




    },
    scrollToTop() {
      // 使用原生JavaScript滚动到页面顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 添加平滑滚动效果，如果不需要可以移除这一行
      });
    },
    openLoginDialog() {
      // console.log('Opening login dialog');
        this.$refs.loginDialog.showLoginDialog();

    },
    login(){

      this.$router.push( {path:'Login'})


    },
    handleLoginSuccess(res) {
      // console.log('Login Success! Code: ' + res.code);
      // 在这里可以将 res.code 发送到后端进行进一步处理
    },
    getWeiXinCode(){

      // 在mounted生命周期钩子中动态添加script标签引入wxLogin.js
      const script = document.createElement('script');
      script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
      script.async = true;
      document.head.appendChild(script);

      // 实例化WxLogin对象
      this.wxLoginObj = new WxLogin({
        self_redirect: true,
        id: 'login_container',
        appid: 'wx1d9a459294b117e7',
        // appid: 'wxf094fc7360e2b164',
        scope: 'snsapi_login',
        // redirect_uri: encodeURIComponent('https://www.yasubit.com'),
        redirect_uri: 'http%3A%2F%2Flocalhost%3A8080%2Fyasubit%2Fusers%2Fwechat%2Fcallback',
        state: 'STATE',
        style: '',
        href: '',

      });

      // 在 setTimeout 中添加事件监听
      setTimeout(() => {
        this.$refs.loginContainer.addEventListener('loginSuccess', this.handleLoginSuccess);
      }, 1000); // 假设 1000 毫秒足够等待脚本加载完成


    },

    handleCommand(command) {
      if (command === "a") {
        this.$router.push({ path: "technology" });
      }
      if (command === "b") {
        this.$router.push({ path: "FAQ" });
      }
      if (command === "c") {
        this.$router.push({ path: "about" });
      }
      if (command === "d") {
        this.$router.push({ path: "contact" });
      }
    },

    technicalIntroduction() {
      // console.log(999999);
      // window.console.log(5555);
    },

    handleSelect(key) {
      this.isShow = this.defaultActive !== key;
      // window.console.log(this.isShow);
    },

    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
    },


    // updateUser(newUser) {
    //   const userData = JSON.stringify(newUser);
    //   Cookies.set("user", userData, { expires: 30 });
    //   this.user = newUser;
    //   this.isLogin = true;
    // },
  },
};
</script>

<style scoped lang="scss">



</style>